import { scrubUrl } from "../../Consent/utils/urlScrub";

/**
 * The URL-bearing fields of a RUM event that `beforeSend` may rewrite.
 *
 * A structural subset rather than the SDK's `RumEvent` union, so this module
 * (and its tests) does not import the SDK. Datadog documents every field here
 * as modifiable in `beforeSend`.
 */
export type RumEventUrls = {
  type?: string;
  view?: { url?: string; referrer?: string };
  resource?: { url?: string };
  error?: { resource?: { url?: string } };
};

/**
 * Strips every non-tracking query parameter and every fragment from the URLs a
 * RUM event carries: the view URL and referrer (present on every event type,
 * including actions, errors and long tasks), a resource's URL, and the URL of
 * the request behind a network error.
 *
 * Runs in every consent mode. Portal URLs carry `?token=` JWTs (magic link,
 * deposit, Medicare assignment), Stripe client secrets on a payment return, and
 * patient record ids, and before this every one of them reached Datadog's US
 * site on the view event alone.
 *
 * Mutates in place, which is what `beforeSend` expects.
 */
export const scrubRumEventUrls = (event: RumEventUrls): void => {
  if (event.view) {
    if (event.view.url) event.view.url = scrubUrl(event.view.url);
    if (event.view.referrer)
      event.view.referrer = scrubUrl(event.view.referrer);
  }
  if (event.resource?.url) event.resource.url = scrubUrl(event.resource.url);
  if (event.error?.resource?.url) {
    event.error.resource.url = scrubUrl(event.error.resource.url);
  }
};
